<div
  class="blue-pill__wrapper"
  [ngStyle]="{ 'height.px': height }"
  [ngClass]="{
    left: textAlign === 'left',
    center: textAlign === 'center',
    right: textAlign === 'right',
  }"
>
  <span
    #textElement
    class="blue-pill__text"
    [ngStyle]="{ 'font-size.px': fontSize }"
    [matTooltip]="text"
    [matTooltipDisabled]="!isOverflow(textElement)"
    >{{ text }}</span
  >
</div>
